import { useTranslation } from "react-i18next";
import UserActivityStatus from "../../../../components/user-activity-status/user-activity-status";
import TableСomponent from "../../../../components/table/table";
import moment from "moment";
import { CheckOutlined } from "@ant-design/icons";
import { useEffect, useState } from "react";
import "../../../../components/icons/styles.css";
import TaskDrawer from "./task-drawer";
import encodeSvgWithColor from "../../../../common/utils/encodeSvgWithColor";

const TasksTable = ({ tasks, initialSubjectTaskId }) => {
  const [isOpenDrawer, setIsOpenDrawer] = useState(false);
  const [task, setTask] = useState(null);
  const { t } = useTranslation();

  useEffect(() => {
    if (!initialSubjectTaskId || !Array.isArray(tasks) || !tasks.length) return;

    const matchedTask = tasks.find(
      (item) => String(item.id) === String(initialSubjectTaskId)
    );

    if (matchedTask) {
      setTask(matchedTask);
      setIsOpenDrawer(true);
    }
  }, [tasks, initialSubjectTaskId]);

  const columns = [
    {
      title: t("subject_management.table.task_name"),
      dataIndex: "name",
      render: (_, taskItem) => {
        const { backgroundColor, avatar, avatarColor, title } =
          taskItem?.DailyTask || {};

        return (
          <div className="tasks-table__name-container">
            <div
              className="icon-wrapper"
              style={{
                backgroundColor,
              }}
            >
              {avatar && (
                <img
                  src={encodeSvgWithColor(avatar, avatarColor)}
                  alt="avatar"
                />
              )}
            </div>
            <p>{title}</p>
          </div>
        );
      },
      key: "id",
      width: "30%",
    },
    {
      title: t("subject_management.table.survey"),
      dataIndex: "survey",
      render: (_, taskItem) => (
        <CheckOutlined
          style={{
            color:
              taskItem.status === "COMPLETED"
                ? "black"
                : "rgba(178, 178, 199, 1)",
          }}
          alt="check"
        />
      ),
      key: "survey",
      width: "10%",
    },
    {
      title: t("subject_management.table.due_date"),
      dataIndex: "dueDate",
      render: (_, taskItem) => (
        <span>
          {`${moment(taskItem.dueDate)
            .utc()
            .format("DD MMM YYYY, HH:mm")}, UTC` || "N/A"}
        </span>
      ),
      key: "due",
      width: "20%",
    },
    {
      title: t("subject_management.table.completion_date"),
      dataIndex: "complete",
      render: (_, taskItem) => (
        <span>
          {taskItem.status === "COMPLETED"
            ? `${moment(taskItem.completedAt)
                .utc()
                .format("DD MMM YYYY, HH:mm")}, UTC` || "N/A"
            : "N/A"}
        </span>
      ),
      key: "completion",
      width: "20%",
    },
    {
      title: t("subject_management.table.status"),
      dataIndex: "status",
      render: (_, user) => (
        <UserActivityStatus userStatus={user.status || "PENDING"} />
      ),
      key: "status",
      width: "20%",
    },
  ];

  const openSurvey = (item) => {
    setTask(item);
    setIsOpenDrawer(true);
  };

  const close = () => {
    setIsOpenDrawer(false);
  };

  return (
    <>
      <TableСomponent
        columns={columns}
        data={tasks}
        onHandleRowClick={openSurvey}
      />
      <TaskDrawer
        isOpenDrawer={isOpenDrawer}
        close={close}
        task={task}
      />
    </>
  );
};

export default TasksTable;